
export const SET_MSG = 'USER_MSG';
export const SET_EDITAR = 'USER_EDITAR';
export const SET_LISTA = 'USER_LISTA';
